/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-nvd3/build/lib/ng2-nvd3.component';
const styles_NvD3Component:any[] = ([] as any[]);
export const RenderType_NvD3Component:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NvD3Component,data:{}});
export function View_NvD3Component_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_NvD3Component_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'nvd3',([] as any[]),
      (null as any),(null as any),(null as any),View_NvD3Component_0,RenderType_NvD3Component)),
      i0.ɵdid(704512,(null as any),0,i1.NvD3Component,[i0.ElementRef],(null as any),
          (null as any))],(null as any),(null as any));
}
export const NvD3ComponentNgFactory:i0.ComponentFactory<i1.NvD3Component> = i0.ɵccf('nvd3',
    i1.NvD3Component,View_NvD3Component_Host_0,{options:'options',data:'data'},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9ub2RlX21vZHVsZXMvbmcyLW52ZDMvYnVpbGQvbGliL25nMi1udmQzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvbm9kZV9tb2R1bGVzL25nMi1udmQzL2J1aWxkL2xpYi9uZzItbnZkMy5jb21wb25lbnQuZC50cyIsIm5nOi8vL2FwcC9ub2RlX21vZHVsZXMvbmcyLW52ZDMvYnVpbGQvbGliL25nMi1udmQzLmNvbXBvbmVudC5kLnRzLk52RDNDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bnZkMz48L252ZDM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO1VBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/~/ng2-nvd3/build/lib/ng2-nvd3.component.ngfactory.ts